export default "__VITE_ASSET__64kVaPMS__"